const iOSDownloadLink = "https://apps.apple.com/kr/app/%EB%B9%84%EA%B8%80%EC%A6%88-%EA%B0%80%EC%83%81-%ED%8E%AB-%ED%9E%90%EB%A7%81-%EC%95%B1-%EB%B0%98%EB%A0%A4%EB%8F%99%EB%AC%BC-%EC%BA%90%EB%A6%AD%ED%84%B0-%EB%A9%94%ED%83%80%EB%B2%84%EC%8A%A4/id1585622161";
const AndroidDownloadLink = "https://play.google.com/store/apps/details?id=com.bigglz.BigglzApp";

/**
 * 브라우저 userAgent에서 iOS 여부를 검사하여
 * iOS라면 앱스토어 링크, 아니라면 구글 플레이스토어 링크를 반환한다.
 * @returns  비글즈 앱 다운로드 링크
 */
export function getDownloadLink() {
    const userAgent = navigator.userAgent.toLowerCase();
    const iPhone = userAgent.indexOf('iphone') > -1;
    const iMac = userAgent.indexOf('mac') > -1;
    const iPad = userAgent.indexOf('pad') > -1;

    if (iMac || iPhone || iPad) {
        return iOSDownloadLink;
    } else {
        return AndroidDownloadLink;
    }
}

/**
 * URL에서 받아온 파라미터를 오브젝트 형식으로 반환한다.
 * ex) www.url.com?member=52&date=202212
 * @param query URL Parameter
 * @returns  쿼리 오브젝트 { member: 52, date: 202212 }
 */
export function splitQuery(query) {
    let splitedQuery = query.replace('?', '').split('&');
    let result = {};
    splitedQuery.forEach(element => {
        let pair = element.split('=');
        result[pair[0]] = pair[1];
    });

    return result;
}

/**
 * 입력받은 yyyyMM의 시작일, 마지막일, 결과발표일을 오브젝트로 반환한다.
 * @param {*} date "yyyyMM"의 숫자로 이루어진 6자리 문자열
 * @returns month, firstDayString, lastDayString, resultDateString
 */
export function getDateString(date = "") {
    let year = 0;
    let month = 0;

    if (typeof date === "string" && date.length === 6) {
        year = Number(date.substring(0, 4));
        month = Number((date.substring(4, 6)).replace("0", "")) - 1;

        if (isNaN(year) || isNaN(month)) {
            date = new Date();
            year = date.getFullYear();
            month = date.getMonth();
        }
    }
    else {
        date = new Date();
        year = date.getFullYear();
        month = date.getMonth();
    }

    const week = ['일', '월', '화', '수', '목', '금', '토'];
    
    const firstDay = new Date(year, month, 1);
    const firstDayLabel = week[firstDay.getDay()];
    const firstDayString = `${year}년 ${month + 1}월 1일 (${firstDayLabel})`;

    const lastDay = new Date(year, month + 1, 0);
    const lastDayLabel = week[lastDay.getDay()];
    const lastDayString = `${month + 1}월 ${lastDay.getDate()}일 (${lastDayLabel})`;

    let resultDateString = "";
    if (month === 11) {// 12월이라면 내년으로 예외처리 
        const resultDate = new Date(year + 1, 0, 7);
        const resultDayLabel = week[resultDate.getDay()]
        resultDateString = `${resultDate.getFullYear()}년 ${resultDate.getMonth() + 1}월 7일 (${resultDayLabel})`;
    }
    else {
        const resultDate = new Date(year, month + 1, 7);
        const resultDayLabel = week[resultDate.getDay()]
        resultDateString = `${resultDate.getFullYear()}년 ${month + 2}월 7일 (${resultDayLabel})`;
    }

    return {
        month: Number(month) + 1,
        firstDayString,
        lastDayString,
        resultDateString
    }
}